export default __webpack_public_path__ + "static/media/icon-created.a700ee13.svg";